<template>
  <div class="content">
    <div>
      <el-select v-model="where2.type" filterable style="width: 200px;" placeholder="选择分类" clearable size="small">
        <el-option
          v-for="(item,index) in [{name:'户数',val:0},{name:'金额',val:1}]"
          :key="index"
          :label="item.name"
          :value="item.val"
        />
      </el-select>
    </div>
    <div class="header-tip">
      月催回率：{{pageData.cot.hs_dy_ch_par||0}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      累计催回率：{{pageData.cot.hs_lj_ch_par||0}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

<!--      月完成率（户数）：{{pageData.cot.hs_dy_par||0}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--      月完成率（金额）：{{pageData.cot.je_dy_par||0}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--      累计完成率（户数）：{{pageData.cot.hs_lj_par||0}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-->
<!--      累计完成率（金额）：{{pageData.cot.je_lj_par||0}}-->
    </div>
    <div class="body">
      <div>
        <div class="table-wrap">
          <el-table
            v-loading="loading"
            v-if="pageData" :data="pageData.list"
            border
            style="width: 100%">
            <el-table-column
              prop="project_name"
              label="项目"
              align="center">
            </el-table-column>
            <el-table-column
              prop="name"
              label="类型"
              align="center">
            </el-table-column>
            <el-table-column
              label="当月完成率" align="center">
              <el-table-column
                prop="dy_jh_count"
                label="计划"
                align="center">
              </el-table-column>
              <el-table-column
                prop="dy_sj_count"
                label="实际"
                align="center">
              </el-table-column>
              <el-table-column
                prop="dy_par"
                label="完成率"
                align="center">
              </el-table-column>
              <el-table-column
                prop="dy_ch_par"
                label="催回率"
                align="center">
              </el-table-column>
            </el-table-column>

            <el-table-column
              label="累计完成率" align="center">
              <el-table-column
                prop="lj_jh_count"
                label="计划"
                align="center">
              </el-table-column>
              <el-table-column
                prop="lj_sj_count"
                label="实际"
                align="center">
              </el-table-column>
              <el-table-column
                prop="lj_par"
                label="完成率"
                align="center">
              </el-table-column>
              <el-table-column
                prop="lj_ch_par"
                label="催回率"
                align="center">
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="pagination-wrap">
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ButlerHttp from "../../common/ButlerHttp";

export default {
  name: "CompletionRate",
  inject:['where','reginWhere'],
  data(){
    return{
      where2:{
        type:0,
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
        cot:{}
      },
      house_bill_order:[],
    }
  },
  mounted() {
    const that=this;
    that.pageChange();
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      this.pageChange()
    },
    "reginWhere.project_region":function (n,o) {
      this.pageChange()
    },
    "reginWhere.project_name":function (n,o) {
      this.pageChange()
    },
    "where2.type":function (n,o) {
      this.pageChange()
    },
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;

      let where = {
        ...that.where2,
        project_ids:that.reginWhere.project_ids,
        project_id:that.reginWhere.project_name,
        age:that.reginWhere.age
        // area_id:that.area_id
      }

      ButlerHttp.post("Legal/getNowCollectionNormal", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i=1) {
      this.pageData.page = i
      this.getList()
    },
  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/legal/CompletionRate.vue